<template>
  <!--在线客服-->
  <div class="shopbox" v-loading="loading">
    <headerbox :focus="5"></headerbox>
    <div class="fixedcolor"></div>
    <div>
      <div class="shop-top">
        <div class="left">
          <img src="../../public/statics/img/shop/logos.png" alt="" />
        </div>

        <div class="right">
          <div class="right-top">
            <div class="top-left">
              <el-input
                style="width: 8.2rem"
                placeholder="GPS"
                v-model="keyword"
                @keyup.enter.native="searchShop(1)"
              ></el-input>
              <div class="search-btn cursor" @click="searchShop(1)">
                <img src="../../public/statics/img/shop/search.png" alt="" />
                <p>搜索</p>
              </div>
            </div>
            <div class="top-right cursor" @click="toshoucang(1)">
              <div class="search-btn cursor">
                <img src="../../public/statics/img/shop/car.png" alt="" />
                我的购物车
                <div class="psf">
                  <!-- <img
                    src="../../public/statics/img/shop/tip.png"
                    alt=""
                    class="ps"
                  /> -->
                  <p>{{ nums.good_count }}</p>
                </div>
              </div>
            </div>
            <div class="top-right cursor" @click="toshoucang(2)">
              <div class="search-btn cursor">
                <img src="../../public/statics/img/shop/cang.png" alt="" />
                我的收藏
                <div class="psf">
                  <!-- <img
                    src="../../public/statics/img/shop/tip.png"
                    alt=""
                    class="ps"
                  /> -->
                  <p>{{ nums.collect_count }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="right-bottom">热门搜索:GPS</div>
        </div>
      </div>
      <div class="shop-content">
        <div class="content-left">
          <img src="../../public/statics/img/shop/left-bannner.jpg" alt="" />
        </div>
        <div class="content-right">
          <img src="../../public/statics/img/shop/right-bannner.png" alt="" />
        </div>
      </div>
      <div class="shop-bottom">
        <div class="rea-serach">
          <div class="serachone">
            <div @click="changeMo" :class="ismo ? 'moc cursor' : 'cursor'">
              默认
            </div>
            <div
              v-if="popularOrder != ''"
              @click="changeRen"
              class="mor cursor"
            >
              人气
              <img src="../../public/statics/img/shop/xJian.png" />
            </div>
            <div v-else class="cursor" @click="changeRen">
              人气
              <img src="../../public/statics/img/shop/down.png" />
            </div>
            <div v-if="salesOrder != ''" @click="changeXiao" class="mox cursor">
              销量
              <img src="../../public/statics/img/shop/xJian.png" />
            </div>
            <div v-else class="cursor" @click="changeXiao">
              销量
              <img src="../../public/statics/img/shop/down.png" />
            </div>

            <div
              v-if="priceOrder != ''"
              class="mop cursor"
              @click="changePrice"
            >
              价格
              <p class="prices">
                <img
                  src="../../public/statics/img/shop/ups.png"
                  v-if="this.priceOrder == 'asc'"
                />
                <img src="../../public/statics/img/shop/downs.png" v-else />
              </p>
            </div>
            <div v-else class="cursor" @click="changePrice">
              价格
              <p class="price">
                <img src="../../public/statics/img/shop/top.png" class="img1" />
                <img src="../../public/statics/img/shop/top.png" />
              </p>
            </div>
          </div>
          <div class="serachtwo">
            <el-input v-model="minPrice" @input="onInput()"></el-input>
            <p>-</p>
            <el-input v-model="maxPrice" @input="onInput()"></el-input>
            <el-button
              style="padding: 0.05rem; margin-left: 0.2rem"
              @click="searchShop(1)"
              >确定</el-button
            >
          </div>
          <div class="serachthree">
            <!-- <el-checkbox-group v-model="checkedCities" :min="0" :max="2">
              <el-checkbox
                v-for="city in cities"
                :label="city"
                :key="city"
                style="font-size: 0.2rem"
                @click.native="choose"
                >{{ city }}</el-checkbox
              >
            </el-checkbox-group> -->
            <el-checkbox
              v-model="selected"
              style="font-size: 0.2rem"
              @change="searchShop(1)"
              >行业精选</el-checkbox
            >
            <el-checkbox
              v-model="adequate"
              style="font-size: 0.2rem"
              @change="searchShop(1)"
              >库存充足</el-checkbox
            >
          </div>
        </div>
        <div class="rea-detail">
          <div
            class="detailone cursor"
            v-for="(item, index) in shopList"
            :key="index"
          >
            <div @click="todetail(item.goods_id)">
              <div class="one-top">
                <img :src="item.image" alt="" v-if="item.image != ''" />
                <img
                  src="../../public/statics/img/shop/none.png"
                  alt=""
                  v-else
                />
              </div>
              <div class="one-contnt-top"><span>￥</span>{{ item.price }}</div>
              <div class="one-contnt-bottom">
                {{ item.goods_name }}
              </div>
            </div>
            <div class="one-bottom">
              <div
                class="search-btn1"
                v-preventClick
                @click="addCang(item.goods_id, item.is_collect)"
              >
                <img
                  src="../../public/statics/img/shop/cang.png"
                  alt=""
                  v-if="item.is_collect == 0"
                />
                <img
                  src="../../public/statics/img/mobile/xin2.png"
                  alt=""
                  v-if="item.is_collect == 1"
                />
                <div>收藏</div>
              </div>

              <div
                class="search-btn2"
                v-preventClick
                @click="addCar(item.goods_id)"
              >
                <img src="../../public/statics/img/shop/car1.png" alt="" />
                <div>加入购物车</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <div>
            <!-- <el-button @click="tostart">首页</el-button> -->
          </div>

          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="page_now"
            :page-size="currentPage"
            layout="prev, pager, next,jumper"
            :total="page_total"
          ></el-pagination>
          <div class="pages">
            <!-- <el-button @click="toend">尾页</el-button> -->
            <!-- <div>共{{ page_total }}页</div> -->
          </div>
        </div>
      </div>
    </div>
    <botbox></botbox>
  </div>
</template>

<script>
import headerbox from "../components/boxtop";
import botbox from "../components/botts";
import { auth, anth } from "../request/api";
import "../../public/statics/css/base.css";
import { getToken, setToken, removeToken } from "../request/toekn";

export default {
  name: "shop",
  data() {
    return {
      loading: true,
      totalpage: 1,

      currentPage: 1,
      page_now: 1,
      page_total: 1,
      checkedCities: [],
      headers: {},
      cities: ["行业精选", "库存充足"],
      shopList: [],
      page: 1,
      keyword: "",
      ismo: true,
      popularOrder: "",
      salesOrder: "",
      priceOrder: "",
      minPrice: "",
      maxPrice: "",
      selected: false,
      adequate: false,
      nums: {
        good_count: 0,
        collect_count: 0,
      },
    };
  },
  components: {
    headerbox,
    botbox,
  },
  mounted() {
    this.headers[getToken()] = Cookies.get(getToken());
    // console.log(this.headers.token);
    document.body.scrollTop = -48;
    document.documentElement.scrollTop = -48;
    setTimeout(() => {
      this.loading = false;
    }, 200);
    this.getNum();
    // this.getshopLgetist();
    console.log(this.$route.query.keyword);
    if (
      this.$route.query.keyword == "" ||
      this.$route.query.keyword == "undefined"
    ) {
      this.keyword = "";
    } else {
      this.keyword = this.$route.query.keyword;
    }
    this.searchShop(1);
  },
  methods: {
    // getshopList() {
    //   let url = "/v1/shop/goods/list";
    //   let data = {
    //     page: 1,
    //   };
    //   auth(url, data).then((res) => {
    //     if (res.data.code == 1) {
    //       // console.log(res);
    //       this.shopList = res.data.data.list;
    //     }
    //   });
    // },
    handleCurrentChange(e) {
      this.page_now = e;
      this.searchShop(e);
    },
    tostart() {
      this.page_now = 1;
      this.searchShop(this.page_now);
    },
    toend() {
      this.page_now = this.page_total;
      this.searchShop(this.page_now);
    },
    addCar(id, unique) {
      let url = "/v1/shop/my/addCart";
      let data = {
        id: id,
        // product_attr_unique: unique,
        num: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.searchShop(this.page_now);
          this.getNum();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    addCang(id, isc) {
      let url = "";
      if (isc == 0) {
        url = "/v1/shop/my/addCollect";
      } else {
        url = "/v1/shop/my/delCollect";
      }
      let data = {
        id: id,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.searchShop(this.page_now);
          this.getNum();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    getNum() {
      let url = "/v1/shop/my/count";
      let data = {};
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.nums.collect_count = res.data.data.collect_count;
          this.nums.good_count = res.data.data.good_count;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    handleAssistClick() {
      this.showAssistForm = true;
      this.showAssistBtn = false;
    },

    searchShop(page) {
      console.log(123);
      console.log(this.selected);
      let pages = "";
      if (page != "undefined") {
        pages = page;
      } else {
        pages = 1;
      }
      let url = "/v1/shop/goods/list";
      let selecteds = 0;
      if (this.selected == false) {
        selecteds = 0;
      } else {
        selecteds = 1;
      }
      let adequates = 0;
      if (this.adequate == false) {
        adequates = 0;
      } else {
        adequates = 1;
      }
      let data = {
        page: pages,
        keyword: this.keyword,
        popularOrder: this.popularOrder,
        salesOrder: this.salesOrder,
        priceOrder: this.priceOrder,
        price_min: this.minPrice,
        price_max: this.maxPrice,
        selected: selecteds,
        adequate: adequates,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.shopList = res.data.data.list;
          // this.currentPage = res.data.data.current_page;
          this.page_now = Number(res.data.data.current_page);
          this.page_total = Number(res.data.data.pageall);
          console.log(this.totalpage);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    toshoucang(e) {
      this.$router.push({
        path: "/shoucang",
        query: {
          types: e,
        },
      });
    },
    choose() {
      console.log(this.checkedCities);
    },
    changeMo() {
      if (this.ismo == true) {
        this.ismo = false;
      } else {
        this.ismo = true;
      }
      this.salesOrder = "";
      this.popularOrder = "";
      this.priceOrder = "";
      this.maxPrice = "";
      this.minPrice = "";
      this.selected = 0;
      this.adequate = 0;
      this.searchShop(1);
    },
    changeRen() {
      this.ismo = false;
      this.salesOrder = "";
      // this.popularOrder = "";
      this.priceOrder = "";
      if (this.popularOrder == "desc") {
        this.popularOrder = "asc";
      } else if (this.popularOrder == "asc") {
        this.popularOrder = "desc";
      } else {
        this.popularOrder = "desc";
      }
      this.searchShop(1);
    },
    changeXiao() {
      this.ismo = false;
      //  this.salesOrder = "";
      this.popularOrder = "";
      this.priceOrder = "";
      if (this.salesOrder == "desc") {
        this.salesOrder = "asc";
      } else if (this.salesOrder == "asc") {
        this.salesOrder = "desc";
      } else {
        this.salesOrder = "desc";
      }
      this.searchShop(1);
    },
    changePrice() {
      this.ismo = false;
      this.salesOrder = "";
      this.popularOrder = "";
      // this.priceOrder = "";
      if (this.priceOrder == "desc") {
        this.priceOrder = "asc";
      } else if (this.priceOrder == "asc") {
        this.priceOrder = "desc";
      } else {
        this.priceOrder = "desc";
      }
      this.searchShop(1);
    },
    onInput() {
      console.log(this.minPrice);
      this.$forceUpdate();
    },
    todetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.shopbox {
  .cursor {
    cursor: pointer;
  }

  .headerbox {
    z-index: 999;
  }
  .fixedcolor {
    width: 100%;
    height: 0.6rem;
    background: #2c3e50;
    position: fixed;
    top: 0;
    z-index: 998;
  }
  .shop-top {
    margin-top: 0.6rem;
    padding: 0.4rem 12%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .left {
      width: 20%;

      img {
        width: 100%;
        // height: 70px;
      }
    }
    .right {
      width: 80%;

      .right-top {
        display: flex;
        justify-content: space-between;
        .top-left {
          // /deep/ .el-input__inner {
          //   height: 51px;
          // }
          height: 0.65rem;
          line-height: 0.65rem;
          .el-input {
            display: flex;
            border: 2px solid #397ea9;
            box-sizing: content-box;
            align-items: center;
          }
          /deep/ .el-input__inner {
            height: 0.45rem;
            line-height: 0.45rem;
            border: none;
            border-radius: 0;
          }
          /deep/ .el-input {
            position: static;
          }
          display: flex;
          justify-content: flex-start;

          .search-btn {
            width: 1.8rem;
            // padding: 0 20px;
            // box-sizing: border-box;
            // padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #397ea9;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            img {
              width: 0.18rem;
              height: 0.18rem;
              margin-right: 10px;
            }
            p {
              font-size: 0.18rem;
              font-family: PingFang SC;
              font-weight: bold;
              line-height: 14px;
              color: #ffffff;
              // letter-spacing: 50px;
            }
          }
        }
        .top-right {
          display: flex;
          justify-content: space-between;
          .search-btn {
            // width: 1.8rem;
            padding: 0 0.18rem;
            box-sizing: border-box;
            // padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            font-size: 0.16rem;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 14px;
            color: #397ea9;
            img {
              width: 0.16rem;
              height: 0.16rem;
              margin-right: 5px;
            }
            // div {
            //   position: relative;
            //   // letter-spacing: 50px;
            // }
            .psf {
              // img{
              //   margin: 0;

              // }
              display: flex;
              align-items: flex-start;
              width: 18px;
              height: 20px;
              margin-left: 2px;
              background-image: url("../../public/statics/img/shop/tip.png");
              background-size: 20px 16px;
              background-repeat: no-repeat;
              justify-content: center;
              p {
                // position: absolute;
                // right: -19px;
                // top: -8px;
                width: 100%;
                text-align: center;
                // height: 17px;
                // font-size: 0.1rem;
                font-family: PingFang SC;
                font-weight: bold;
                // line-height: 14px;
                color: #fff;
                // letter-spacing: 50px;
                opacity: 1;
              }
            }
            // .ps {
            //   position: absolute;
            //   right: -30px;
            //   top: -10px;
            // }
          }
        }
      }
      .right-bottom {
        text-align: left;
      }
    }
  }
  .shop-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 12%;
    box-sizing: border-box;
    height: 6.37rem;
    overflow-y: hidden;
    .content-left {
      width: 77%;

      overflow-x: hidden;
      img {
        height: 6.37rem;
        width: 100%;
      }
    }
    .content-right {
      padding-left: 0.35%;
      overflow: hidden;
      width: 22.65%;

      box-sizing: content-box;
      img {
        height: 6.37rem;
        width: 100%;
      }
    }
  }
  .shop-bottom {
    padding: 0.4rem 12%;
    box-sizing: border-box;

    .rea-serach {
      display: flex;
      justify-content: start;
      align-items: center;
      // padding: 0.2rem;
      background: #efefef;
      opacity: 1;
      border-radius: 2px;
      .serachone {
        display: flex;
        align-items: center;
        // height: 48px;
        div {
          padding: 0 0.3rem;
          box-sizing: border-box;
          line-height: 0.6rem;
          height: 0.6rem;
          font-size: 0.2rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          opacity: 1;
          display: flex;
          align-items: center;
          border-right: 1px solid rgba(153, 153, 153, 0.31);
          img {
            width: 0.1rem;
            height: 0.2rem;
            margin-left: 0.2rem;
          }
        }
        .price {
          margin-left: 0.1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          img {
            margin-left: 0;
            width: 0.1rem;
            height: 0.08rem;
          }
          .img1 {
            margin-bottom: 2px;
            transform: rotate(180deg);
          }
        }
        .prices {
          margin-left: 0.1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          img {
            margin-left: 0;
            width: 0.1rem;
            height: 0.2rem;
          }
        }
      }
      .serachtwo {
        display: flex;
        align-items: center;
        padding: 0 0.3rem;
        box-sizing: border-box;
        height: 0.4rem;
        .el-input {
          position: static !important;
        }
        /deep/ .el-input__inner {
          width: 0.6rem;
          height: 0.3rem;
          // padding: 0;
          padding: 0.1rem;
        }
        /deep/ .el-button {
          font-size: 0.2rem;
        }

        p {
          margin: 0 5px;
        }
        border-right: 1px solid rgba(153, 153, 153, 0.31);
      }
      .serachthree {
        display: flex;
        align-items: center;
        margin-left: 15px;
        position: static !important;
        /deep/ .el-checkbox-group {
          position: static !important;
        }
        /deep/ .el-checkbox {
          position: static !important;
        }

        /deep/ .el-checkbox__inner {
          // position: static !important;
          width: 20px;
          height: 20px;
        }
        /deep/ .el-checkbox__inner::after {
          height: 11px;
          width: 6px;
          left: 6px;
          top: 1px;
        }
        /deep/ .el-checkbox__input {
          position: static !important;
        }
        /deep/ .el-checkbox__label {
          font-size: 0.2rem;
          position: static !important;
        }
      }
    }
    .rea-detail {
      margin: 0.8rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      .detailone {
        flex: 1;
        min-width: 24.4%;
        max-width: 24.4%;
        display: inline-block;
        padding: 0.3rem 0.55rem;
        box-sizing: border-box;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.28);

        .one-top {
          padding: 0.42rem 0rem;
          box-sizing: border-box;
          width: 100%;
          height: 7rem;

          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
          }
        }
        .one-contnt-top {
          margin-top: 0.5rem;
          padding: 0.1rem 0;
          box-sizing: border-box;
          font-size: 0.45rem;
          text-align: left;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 0.45rem;
          color: #ff9a26;
          opacity: 1;
          span {
            font-size: 0.3rem;
          }
        }
        .one-contnt-bottom {
          font-size: 0.2rem;
          text-align: left;
          font-family: PingFang SC;
          font-weight: bold;
          height: 0.6rem;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 0.3rem;
          color: #333333;
          opacity: 1;
        }
        .one-bottom {
          margin-top: 0.5rem;
          display: flex;
          justify-content: start;
          align-items: center;
          border: 1px solid #707070;
          div {
            font-size: 0.2rem;
            line-height: 0.2rem;
          }
          .top-right {
            padding: 0.1rem 0.43rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background: #ffffff;
            border: 2px solid #397ea9;
            opacity: 1;
            box-sizing: border-box;
            // width: 80px;
          }
          .search-btn1 {
            display: flex;
            align-items: center;
            padding: 0.075rem 0.2rem;
            box-sizing: border-box;
            // height: 22px;
            // font-size: 16px;
            // font-family: PingFang SC;
            // font-weight: bold;
            // line-height: 21px;
            // color: #FF9A26;
            // opacity: 1;
            img {
              margin-right: 5px;
              width: 0.2rem;
              height: 0.175rem;
            }
            border-right: 1px solid #707070;
          }
          .search-btn2 {
            display: flex;
            align-items: center;
            color: rgba(255, 154, 38, 1);
            // padding: 5px 20px;
            padding: 0.075rem 0.2rem;
            // height: 22px;
            // font-size: 16px;
            // font-family: PingFang SC;
            // font-weight: bold;
            // line-height: 21px;
            // color: #FF9A26;
            // opacity: 1;
            img {
              margin-right: 5px;
              width: 0.2rem;
              height: 0.175rem;
            }
          }
        }
      }
      .detailone:hover {
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.4);
      }
    }
    .pagination {
      margin-bottom: 1rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      opacity: 1;
      /deep/ .el-button {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
      }
      /deep/ .el-pagination__jump {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
      }
      /deep/ .number {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .el-icon-more {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .el-pagination__editor {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.7rem;
        height: 0.5rem;
        line-height: 0.5rem;
        // border: 1px solid #d8d8d8;
      }
      /deep/ .el-input__inner {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.3rem;
        line-height: 0.3rem;
        margin: 0 0.1rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ li {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .btn-prev {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .btn-prev:disabled {
        color: #ccc;
      }
      /deep/ .btn-next:disabled {
        color: #ccc;
      }
      /deep/ .btn-next {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .btn-quickprev {
        font-size: 0.2rem;
        font-family: PingFang SC !important;
        font-weight: bold;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border: 1px solid #d8d8d8;
      }
      /deep/ .btn-quickprev:before {
        content: "<<";
        // color: #333333;
      }
      /deep/ .btn-quicknext:before {
        content: ">>";
        // color: #333333;
      }
      /deep/ .el-icon-more:before {
        content: "...";
      }

      .pages {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
    // .shadow {

    // }
  }
  .moc {
    background-color: rgba(57, 126, 169, 1);
    color: #fff !important;
  }
  .mor {
    background-color: rgba(57, 126, 169, 1);
    color: #fff !important;
  }
  .mox {
    background-color: rgba(57, 126, 169, 1);
    color: #fff !important;
  }
  .mop {
    background-color: rgba(57, 126, 169, 1);
    color: #fff !important;
  }
}
</style>
